<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <div style="text-align: right;margin: 20px;">
            <el-tooltip class="item" effect="dark" content="一定要保存哦" placement="top">
              <el-button type="primary" round @click="saveNotice">保存并返回</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除已发通知" placement="top">
              <el-button type="primary" round @click="delNotice" v-if="showDeleteButn=='1'">删除通知</el-button>
            </el-tooltip>
            <el-button type="primary" round @click="back()">取消</el-button>
          </div>
          <div style="text-align: center;margin: 20px;font-size:16px;color:red;">此公告会显示在手机端成绩查询结果底部(建议字体大小14或16)</div>
          <div style="margin: 20px;">
            <ckeditor ref="ckeditor" v-model="notice_content" :config="config" @ready="onEditorReady"></ckeditor>
          </div>
          <div style="text-align: right;margin: 20px;">
            <el-tooltip class="item" effect="dark" content="一定要保存哦" placement="top">
              <el-button type="primary" round @click="saveNotice">保存并返回</el-button>
            </el-tooltip>
            <el-button type="primary" round @click="back()">取消</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.exam_key = this.$route.params.exam_key
      this.page_from = this.$route.params.page_from
      this.exam_name = this.$route.params.exam_name
      // console.log('传递过来的参数是:' + this.examID)
      this.loadData()
    },
    data() {
      return {
        exam_key: '',
        notice_content: '',

        config: {
          height: 400,
          // 富文本功能项
          extraPlugins: 'colorbutton, colordialog, font, indent, justify, showblocks,uploadimage',
          // 本地图片上传(ckeditor官网有解释)
          filebrowserImageUploadUrl: 'http://localhost:8081/score/web/_upload_image.jsp',
          filebrowserUploadUrl: '/score/tem/'
        },

        page_from: '',
        exam_name: '',
        showDeleteButn: '0'
      }
    },

    methods: {
      loadData() {
        // console.log('加载数据/score/web/_load_exam.jsp')
        let that = this
        var requestUrl = '/score/web/_load_exam_notice.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_key: that.exam_key
            }
          }).then(function(response) {
            if (response.data.show_delete === '1') {
              that.notice_content = response.data.notice.content
              that.showDeleteButn = '1'
            } else {
              that.notice_content = ''
              that.showDeleteButn = '0'
            }

            console.log(that.notice_content)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      back() {
        let that = this

        if (that.page_from === 'detail') {
          that.$router.push({
            name: 'exam_detail',
            params: {
              id: that.exam_key,
              // course: course,
              exam: that.exam_key
            }
          })
        } else {
          that.$router.go(-1)
        }
      },
      saveNotice() {
        let that = this

        // 数据校验
        // if (this.editForm.course === '') {
        //    this.$message.error('请选择科目')
        //    return
        // }
        if (this.notice_content === '') {
          this.$message.error('请输入内容')
          return
        }

        var requestUrl = '/score/web/_exam_notice_save.jsp'

        this.axios.get(requestUrl, {
            params: {
              exam_key: that.exam_key,
              // exam_key: 23223,
              notice_content: that.notice_content
            }
          }).then(function(response) {
            that.$message.success('保存成功！')
            // that.$router.push('/exam_list')

            if (that.page_from === 'detail') {
              that.$router.push({
                name: 'exam_detail',
                params: {
                  id: that.exam_key,
                  // course: course,
                  exam: that.exam_key
                }
              })
            } else {
              that.$router.go(-1)
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      delNotice() {
        let that = this
        this.msg = '要删掉此通知吗？'

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var requestUrl = '/score/web/_delete_exam_notice.jsp'
          this.axios.get(requestUrl, {
              params: {
                exam_key: that.exam_key
              }
            }).then(function(response) {
              that.$message.success('删除成功！')
              that.$router.go(-1)
            })
            .catch(function(error) {
              console.log(error)
            })
        }).catch(() => {

        })
      },
      onEditorReady() {
        const editor = this.$refs.ckeditor.instance
        editor.on('fileUploadRequest', function(evt) {
          const formData = new FormData()
          const fileLoader = evt.data.fileLoader
          const {
            xhr,
            uploadUrl,
            file,
            fileName
          } = fileLoader
          xhr.open('post', uploadUrl)
          // 这里可以根据自己需要添加token等其他头信息
          xhr.setRequestHeader('token', getToken())
          formData.append('file', file, fileName)
          xhr.send(formData)
          evt.stop()
        })
        editor.on('fileUploadResponse', function(evt) {
          evt.stop()
          const xhr = evt.data.fileLoader.xhr
          const res = JSON.parse(xhr.responseText)
          // 自己处理返回逻辑
          if (res.ret !== 0) {
            evt.data.message = res.message
            evt.cancel()
          } else {
            evt.data.url = res.data.url
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/exam_edit_html.vue